import { ReactNode, useEffect, useState } from "react";

import { Spinner } from "components/Spinner";
import { IconComponent } from "types/Icon";

import Icon, { IconProps } from "../Icon";

export type LoadingIndicatorProps = {
  loading?: boolean;
  className?: string;
  minimumDuration?: number;
  size?: IconProps["size"];
  children?: ReactNode;
  icon?: IconComponent;
};

const LoadingIndicator = ({
  loading = false,
  className,
  size = "default",
  minimumDuration,
  children,
  icon: IconSrc = Spinner,
}: LoadingIndicatorProps) => {
  const [isLoading, setIsLoading] = useState(loading);

  if (loading && !isLoading) {
    setIsLoading(true);
  }

  if (!loading && isLoading && !minimumDuration) {
    setIsLoading(false);
  }

  useEffect(() => {
    if (!minimumDuration || loading || !isLoading) {
      return;
    }

    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, minimumDuration);

    return () => clearTimeout(timeoutId);
  }, [isLoading, loading, minimumDuration]);

  return (isLoading && <Icon src={IconSrc} className={className} size={size} />) || <>{children}</>;
};

LoadingIndicator.displayName = "DS.LoadingIndicator";

export default LoadingIndicator;
